import { render, staticRenderFns } from "./Corrected.vue?vue&type=template&id=60b8c698&scoped=true&"
import script from "./Corrected.vue?vue&type=script&lang=js&"
export * from "./Corrected.vue?vue&type=script&lang=js&"
import style0 from "./Corrected.vue?vue&type=style&index=0&id=60b8c698&prod&lang=scss&"
import style1 from "./Corrected.vue?vue&type=style&index=1&id=60b8c698&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b8c698",
  null
  
)

export default component.exports